/* eslint-disable new-cap */
/* eslint-disable camelcase */
/* globals __DEV__ */
import Phaser from 'phaser';
import gameData from '../gameData';
import SoundButton from '../objects/SoundButton';
import BasicSprite from '../objects/BasicSprite';
import StarField from '../objects/StarField';
import LevelSelect_Star from '../objects/LevelSelect/LevelSelect_Star';
import DoorScene from './DoorScene';
import Game from './Game';
import AudioPlayer from '../library/AudioPlayer';
import ABCyaPhaser, { Audio } from '@abcya/abcya_phaser';

export default class LevelSelect extends Phaser.Scene {
  static get KEY() {return 'LevelSelect';}

  create() {
    this.background = new BasicSprite(this, this.scale.width * .5, this.scale.height * .5, 'bg1');
    this.add.existing(this.background);
    this.starField = new StarField(this);

    gameData.curLevel = 1;
    gameData.indexStart = 0;

    /** @type {LevelSelect_Star[]} */
    this.stars = [];
    const countBy = [1, 2, 3, 5, 10];
    const starY = this.scale.height * .5 + 60;
    const numStars = 5;
    const starSpace = 170;
    const startX = 180;

    AudioPlayer.PlaySound(this, AudioPlayer.sounds.CHOOSE_NUMBER, false, 1, Audio.LOCALIZATION_AUDIO_SPRITE);

    for (let i = 0; i < numStars; i++) {
      this.stars.push(new LevelSelect_Star(this, startX + (starSpace * i), starY, countBy[i], this.levelSelected.bind(this)));
    }

    const text = this.add.bitmapText(this.scale.width / 2, this.scale.height / 2 - 160, 'Nasalization', ABCyaPhaser.Localization.instance.getLocalizedString('choose_number_text'), 70);
    text.setOrigin(.5);
    text.setCenterAlign();
    text.setTint(0x99fe7c);

    this.soundButton = new SoundButton(this, this.scale.width - 60, 60);
  }

  levelSelected(star) {
    this.soundButton.button.button.disableInteractive();
    gameData.countBy = star.starButton.countBy;
    for (let i = 0; i < this.stars.length; i++) {
      this.stars[i].starButton.disableInteractive();
    }

    this.scene.get(DoorScene.KEY).changeScene(LevelSelect.KEY, Game.KEY);
  }

  update() {
    for (let i = 0; i < this.stars.length; i++) {
      // eslint-disable-next-line new-cap
      this.stars[i].Update();
    }
  }
}
